import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import Text from '../components/Text'
import request from '../utils/request'

const Box = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

const Message = styled.span`
  font-size: 1.3rem;
  font-weight: 300;
  line-height: 200%;
`

@observer
class CheckLoginStatus extends Component {
  @observable loading = false
  @observable noConnection = false
  @observable loaded = false
  attempts = 0

  @action
  setLoading = () => {
    this.loading = true
    this.noConnection = false
    this.loaded = false
  }

  @action
  setNoConnection = () => {
    this.loading = false
    this.noConnection = true
    this.loaded = false
  }

  @action
  setLoaded = () => {
    this.loading = false
    this.noConnection = false
    this.loaded = true
  }

  checkStatus = async () => {
    const { loggedInRedirect, loggedOutRedirect } = this.props

    if (this.attempts === 1) {
      this.setLoading()
    } else if (this.attempts === 5) {
      this.setNoConnection()
      return
    }

    this.attempts++
    const res = await request('/api/auth/checkStatus')

    if (res.success) {
      if (res.data.loggedIn && loggedInRedirect) {
        window.location = loggedInRedirect
      } else if (!res.data.loggedIn && loggedOutRedirect) {
        window.location = loggedOutRedirect
      }

      this.setLoaded()
    } else {
      setTimeout(this.checkStatus, 2000)
    }
  }

  componentDidMount() {
    this.checkStatus()
    
    // This line is a hack. We just need to scroll top on every page change, and this
    // component is used on every page.
    document.body.scrollTop = document.documentElement.scrollTop = 0
  }

  render() {
    const { children } = this.props

    if (this.loading) {
      return (
        <Box>
          <Message><Text str="prose.loading" /></Message>
        </Box>
      )
    }

    if (this.noConnection) {
      return (
        <Box>
          <Message><Text str="prose.couldntContactServer" /></Message>
          <Message><Text str="prose.checkConnectionReload" /></Message>
        </Box>
      )
    }

    return children
  }
}

export default withRouter(CheckLoginStatus)



// WEBPACK FOOTER //
// ./src/conditions/CheckLoginStatus.js